import { type TFunction } from 'i18next'
import qs from 'query-string'

export enum AttributeType {
  MAKE = 'car_make',
  BODY_TYPE = 'body_type',
  FUEL_TYPE = 'fuel_type',
}

const attributeIdPerType = {
  [AttributeType.BODY_TYPE]: 138,
  [AttributeType.FUEL_TYPE]: 166,
  [AttributeType.MAKE]: 138,
}

export const addAttributeParamToUrl = (
  type: AttributeType,
  href: string,
  canonicalNames: string[],
  t: TFunction
): string => {
  const url = new URL(href)
  const pathname = url.pathname

  // Separate segments and remove any empty ones
  const segments = pathname.split('/')
  const lastIndex = segments.length - 1

  const seoParam = canonicalNames.reduce((acc: string, curr: string) => {
    const i18n = t(`srp:search_by_${type}.${curr}.seo_param`)

    if (!acc) return i18n
    return `${acc}__${i18n}`
  }, '')

  const attributeId = attributeIdPerType[type]

  // Add "a" to the last parameter of the url and the body-type path to the URL
  segments[lastIndex] = `${segments[lastIndex]}a${attributeId}`
  segments.splice(lastIndex, 0, seoParam)

  const { query } = qs.parseUrl(href)
  url.pathname = segments.join('/')

  return qs.stringifyUrl({ url: url.href, query })
}
